import React, {Component} from 'react'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Container from '@mui/material/Container'
import Checkbox from '@mui/material/Checkbox'
import FormGroup from '@mui/material/FormGroup'
import FormLabel from '@mui/material/FormLabel'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Grid from '@mui/material/Grid'
import CardActions from '@mui/material/CardActions'
import { Alert, AlertTitle, Box, Collapse, Paper, Snackbar, Typography } from '@mui/material'

const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')

class ClientesEditarPage extends Component {

    constructor(props) {
        super(props)

        this.idCliente = props.location.state.id_cliente
        this.entidadesSeleccionadas = []

        this.state = {
            cliente: {},
            txtNombre: "",
            txtCodigo: "",
            cmbEntidades: 0,
            entidades: [],
            cajeros: [],
            cajerosDisponibles: [],
            cajerosCliente: [],
            gruposCajerosDisponibles: [],
            gruposCajerosClientes: [],

            // Asignacion MULTIPLE de entidades al depositante (adicional a la entidad
            // principal id_entidad). entidadesCliente = asignadas; las disponibles se
            // derivan de 'entidades' (todas) menos las asignadas. Filtros de busqueda
            // para operar comodo con muchas entidades (ej. 130).
            entidadesCliente: [],
            filtroEntidadDisp: '',
            filtroEntidadAsig: '',

            mostrarAlerta: false,
            mensajeAlerta: '',
            severidadAlerta: 'info'
        }
    }

  handleCloseAlert= (event, reason) => {
      if (reason === 'clickaway') {
        return; // Evitar que se cierre si el usuario hace clic fuera
      }
      this.setState({ mostrarAlerta: false })
  }

  onChangetxtNombre = (event) => {
      const nombre = event.target.value.toString()
      this.setState({txtNombre: nombre})
  }


  onChangetxtCodigo= (event) => {
    // Identificación: solo dígitos, máximo 10
    const codigo = event.target.value.toString().replace(/\D/g, '').slice(0, 10)
    this.setState({txtCodigo: codigo})
  }

  onChangecmbEntidades= (event) => {
    const entidad = event.target.value
    this.setState({cmbEntidades: entidad})
  }

  actualizarCajerosDisponibles() {
    var cajeros = this.state.cajeros
    
    var cajerosDisponibles = []
    var gruposDisponibles = []
    var cajerosCliente = this.state.cajerosCliente

    cajeros.forEach((cajero) => {
      if(cajero.tipo === 1) {
        var blnAgregar = true

        cajerosCliente.forEach((cajeroCliente) => {
          if(cajeroCliente.tipo === 1 && cajeroCliente.id === cajero.id) {
            blnAgregar = false
          }
        })
  
        if(blnAgregar) {
          cajerosDisponibles.push(cajero)
        }
      } else {
        /* eslint-disable no-redeclare */
        var blnAgregar = true
        /* eslint-enable no-redeclare */

        cajerosCliente.forEach((cajeroCliente) => {
          if(cajeroCliente.tipo === 2 && cajeroCliente.id === cajero.id) {
            blnAgregar = false
          }
        })

        if(blnAgregar) {
          gruposDisponibles.push(cajero)
        }
      }
      
    })
    
    this.setState({
      cajerosDisponibles: cajerosDisponibles,
      gruposCajerosDisponibles:gruposDisponibles
    })
  }

  actualizarGruposCajerosDisponibles() {
    var grupos = this.state.gruposCajeros
    
    var gruposCajerosDisponibles = []
    var gruposCajerosClientes = this.state.gruposCajerosClientes

    grupos.forEach((grupo) => {
      var blnAgregar = true

      gruposCajerosClientes.forEach((grupoCliente) => {
        
        if(grupoCliente.id === grupo.id) {
          blnAgregar = false
        }
      })

      if(blnAgregar) {
        gruposCajerosDisponibles.push(grupo)
      }
    })
    
    this.setState({
      gruposCajerosDisponibles: gruposCajerosDisponibles
    })
  }

  agregarCajero(cajeroNuevo) {
    var cajerosDisponibles = this.state.cajerosDisponibles
    var gruposCajerosDisponibles = this.state.gruposCajerosDisponibles
    var cajerosCliente = this.state.cajerosCliente

    if(cajeroNuevo.tipo === 1) {
      cajerosDisponibles.forEach((cajero) => {
        if(cajero.tipo === cajeroNuevo.tipo && cajero.id === cajeroNuevo.id) {
          cajerosCliente.push(cajero)
        }
      })
    } else {
      gruposCajerosDisponibles.forEach((cajero) => {
        if(cajero.tipo === cajeroNuevo.tipo && cajero.id === cajeroNuevo.id) {
          cajerosCliente.push(cajero)
        }
      })
    }

    this.setState({
      cajerosCliente: cajerosCliente
    })

    this.actualizarCajerosDisponibles()
  }

  removerCajero(cajeroRemover) {
    var cajerosCliente = this.state.cajerosCliente

     for(var x = 0; x < cajerosCliente.length; x++) {
      if(cajerosCliente[x].tipo === cajeroRemover.tipo && cajerosCliente[x].id === cajeroRemover.id) {
        cajerosCliente.splice(x, 1) 
        break
      }
    }


    this.setState({
      cajerosCliente: cajerosCliente
    })

    this.actualizarCajerosDisponibles()
  }

    componentDidMount() {
        this.queryCliente()
        this.queryEntidades()
        this.queryCajeros()
        this.queryCajerosCliente()
        this.queryEntidadesCliente()
    }

    btnActualizarClienteClick = () => {
        console.log('Actualizando cliente....')

        var continuar = true
        var mensajeError = "Error:\n"

        var nombre = this.state.txtNombre
        var codigo = this.state.txtCodigo

        nombre = nombre.trim()
        codigo = codigo.trim()
        
        if(nombre === '') {
          continuar = false
          mensajeError += " * Debe ingresar el nombre.\n"
        }


        if(codigo === '') {
          continuar = false
          mensajeError += " * Debe ingresar la identificación.\n"
        }

        if(continuar) {
			var restArgs = {
		      method: 'PATCH',
		      headers: 'JSON',
		      body: {
			  	id_cliente: this.state.cliente.id,
                nombre: nombre,
                codigo: codigo
			  },
		      url: process.env.REACT_APP_URL_BACKEND + '/clientes/cliente/edit'
		    }
		
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
	        //console.log('Error respuesta actualizar cliente')
            //alert("Se produjo un error actualizando el cliente")
            this.setState({
              mostrarAlerta: true,
              mensajeAlerta: 'Se produjo un error actualizando el cliente',
              severidadAlerta: 'error'
            })
	      } else {
            //console.log('Cliente actualizado')
            //alert("Cliente Actualizado")
            this.setState({
              mostrarAlerta: true,
              mensajeAlerta: 'Cliente Actualizado',
              severidadAlerta: 'success'
            })
	      }
	    })
		    
	  } else {
	      //alert(mensajeError)
        this.setState({
          mostrarAlerta: true,
          mensajeAlerta: mensajeError,
          severidadAlerta: 'error'
        })
	    }
        
    }


  btnGuardarCajerosClick = () => {
    var cajerosCliente = this.state.cajerosCliente
    var cajeros = []
    var mensajeError = "Error:\n"
    var continuar = true

    
     
    cajerosCliente.forEach((cajero) => {
        cajeros.push(
            {
              tipo: cajero.tipo,
              id: cajero.id
            }
          )
    })
    
    
    if(continuar) {
		var restArgs = {
		      method: 'PATCH',
		      headers: 'JSON',
		      body: {
			  	id_cliente: this.state.cliente.id,
	            cliente: this.state.cliente.nombre + ' ' + this.state.cliente.codigo,
	            cajeros: cajeros
			  },
		      url: process.env.REACT_APP_URL_BACKEND + '/clientes/cliente/cajeros'
		    }
		
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
	        //console.log('Error respuesta actualizar cajeros')
            //alert("Se produjo un error actualizando los cajeros")
            this.setState({
              mostrarAlerta: true,
              mensajeAlerta: 'Se produjo un error actualizando los cajeros',
              severidadAlerta: 'error'
            })
	      } else {
            // console.log('Cajeros actualizados')
            // alert("Cajeros Actualizados")
            this.setState({
              mostrarAlerta: true,
              mensajeAlerta: 'Cajeros Actualizados',
              severidadAlerta: 'success'
            })
	      }
	    })
	} else {
      //alert(mensajeError)
      this.setState({
        mostrarAlerta: true,
        mensajeAlerta: mensajeError,
        severidadAlerta: 'error'
      })
    }
  }

  cambiarEstado() {
      var estado = this.state.cliente.estado
      
      switch(estado) {
          case "I":
              estado = "A"
              break
          case "A":
              estado = "I"
              break
          default:
              break
      }

      console.log('Actualizando cliente....')

		var restArgs = {
		      method: 'PATCH',
		      headers: 'JSON',
		      body: {
			  	id_cliente: this.idCliente,
	              cliente: this.state.cliente.nombre + ' ' + this.state.cliente.codigo,
	              estado: estado
			  },
		      url: process.env.REACT_APP_URL_BACKEND + '/clientes/cliente/estado/'
		    }
		
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
	        //console.log('Error respuesta actualizar cliente')
            //alert("Se produjo un error actualizando el cliente")
            this.setState({
              mostrarAlerta: true,
              mensajeAlerta: 'Se produjo un error actualizando el cliente',
              severidadAlerta: 'error'
            })
	      } else {
            //console.log('Cliente acutalizado')
            //alert("Cliente acutalizado")
            this.setState({
              mostrarAlerta: true,
              mensajeAlerta: 'Cliente acutalizado',
              severidadAlerta: 'success'
            })
            this.queryCliente()
	      }
	    })

    }

    queryCliente() {
        //console.log('Consultando cliente....')
        
        var restArgs = {
		      method: 'POST',
		      headers: 'JSON',
		      body: {
			  	id_cliente: this.idCliente
			  },
		      url: process.env.REACT_APP_URL_BACKEND + '/clientes/detalle'
		    }
		
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
	        //console.log('Error respuesta consultando cliente')
            this.setState({
            	mensajeError: data.message,
              mostrarAlerta: true,
              mensajeAlerta: 'Se produjo un error consultando el cliente',
              severidadAlerta: 'error'
            })
            // alert("Se produjo un error consultando el cliente")
	      } else {
            console.log('Cliente consultado')

			var cliente = data

            this.setState({
                cliente: cliente,
                txtNombre: cliente.nombre,
                txtCodigo: cliente.codigo,
                cmbEntidades: cliente.id_entidad
            })
	      }
	    })
        
    }

    queryEntidades() {
        console.log('Consultando entidades....')
        var restArgs = {
	      method: 'POST',
	      headers: 'JSON',
	      body: {},
	      url: process.env.REACT_APP_URL_BACKEND + '/entidades/usuario/list'
	    }
	
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
	        //alert("Error consultando entidades")
	        //console.log('Error respuesta consultando entidades')
              this.setState({
				        entidades: [],
                mensajeError: data.message,
                mostrarAlerta: true,
                mensajeAlerta: 'Error consultando entidades',
                severidadAlerta: 'error'
              })
	      } else {
	        //console.log('Entidades consultadas')
              this.setState({
                entidades: data
                })
	      }
	    })
        
      }

      queryCajeros() {
        //console.log('Consultando cajeros....')
        var restArgs = {
	      method: 'POST',
	      headers: 'JSON',
	      body: {},
	      url: process.env.REACT_APP_URL_BACKEND + '/cajerosgrupos/cajerosygrupos/list'
	      }
	
	      RestTunel.makePetition(restArgs,(err, data) => {
          if(err) {
            //alert("Error consultando cajeros")
            //console.log('Error respuesta consultando cajeros')
            this.setState({
              cajeros: [],
              mensajeError: data.message,
              mostrarAlerta: true,
              mensajeAlerta: 'Error consultando cajeros',
              severidadAlerta: 'error'
            })
          } else {
            // console.log('Cajeros consultados')
            this.setState({
              cajeros: data,
              mostrarAlerta: true,
              mensajeAlerta: 'Cajeros consultados',
              severidadAlerta: 'success'
            })
            this.actualizarCajerosDisponibles()
          }
        })
      }


      queryCajerosCliente() {
        console.log('Consultando cajeros cliente....')
        var restArgs = {
	      method: 'POST',
	      headers: 'JSON',
	      body: {
			  id_cliente: this.idCliente
		    },
	      url: process.env.REACT_APP_URL_BACKEND + '/clientes/cajerosgrupos/list'
        }
    
        RestTunel.makePetition(restArgs,(err, data) => {
          if(err) {
            //alert("Error consultando cajeros cliente")
            // console.log('Error respuesta consultando cajeros clientes')
                this.setState({
                  mensajeError: data.message,
                  mostrarAlerta: true,
                  mensajeAlerta: 'Error consultando cajeros cliente',
                  severidadAlerta: 'error'
                })
          } else {
              console.log('Cajeros clientes consultados')
                this.setState({
                  cajerosCliente: data
                })
                this.actualizarCajerosDisponibles()
          }
        })
      }


      // ---------- Asignacion MULTIPLE de entidades al depositante ----------
      queryEntidadesCliente() {
        var restArgs = {
          method: 'POST',
          headers: 'JSON',
          body: { id_cliente: this.idCliente },
          url: process.env.REACT_APP_URL_BACKEND + '/clientes/entidades/list'
        }
        RestTunel.makePetition(restArgs, (err, data) => {
          if(err) {
            this.setState({
              mostrarAlerta: true,
              mensajeAlerta: 'Error consultando entidades del depositante',
              severidadAlerta: 'error'
            })
          } else {
            this.setState({ entidadesCliente: Array.isArray(data) ? data : [] })
          }
        })
      }

      // Disponibles = todas las entidades del usuario (state.entidades) menos las ya
      // asignadas, aplicando el filtro de busqueda. Se calcula al vuelo (no en estado).
      entidadesDisponiblesFiltradas() {
        var filtro = (this.state.filtroEntidadDisp || '').toLowerCase()
        var asignadasIds = this.state.entidadesCliente.map(e => e.id)
        return this.state.entidades
          .filter(e => asignadasIds.indexOf(e.id) === -1)
          .filter(e => (e.nombre || '').toLowerCase().includes(filtro))
      }

      entidadesAsignadasFiltradas() {
        var filtro = (this.state.filtroEntidadAsig || '').toLowerCase()
        return this.state.entidadesCliente
          .filter(e => (e.nombre || '').toLowerCase().includes(filtro))
      }

      agregarEntidad(entidad) {
        var asignadas = this.state.entidadesCliente.slice()
        if(asignadas.findIndex(e => e.id === entidad.id) === -1) {
          asignadas.push({ id: entidad.id, nombre: entidad.nombre })
        }
        this.setState({ entidadesCliente: asignadas })
      }

      removerEntidad(entidad) {
        var asignadas = this.state.entidadesCliente.filter(e => e.id !== entidad.id)
        this.setState({ entidadesCliente: asignadas })
      }

      // Agrega TODAS las disponibles que pasan el filtro actual (accion masiva).
      agregarEntidadesFiltradas() {
        var nuevas = this.entidadesDisponiblesFiltradas()
        if(nuevas.length === 0) { return }
        var asignadas = this.state.entidadesCliente.slice()
        nuevas.forEach(e => {
          if(asignadas.findIndex(a => a.id === e.id) === -1) {
            asignadas.push({ id: e.id, nombre: e.nombre })
          }
        })
        this.setState({ entidadesCliente: asignadas })
      }

      // Quita TODAS las asignadas que pasan el filtro actual (accion masiva).
      quitarEntidadesFiltradas() {
        var quitarIds = this.entidadesAsignadasFiltradas().map(e => e.id)
        var asignadas = this.state.entidadesCliente.filter(e => quitarIds.indexOf(e.id) === -1)
        this.setState({ entidadesCliente: asignadas })
      }

      onChangeFiltroEntidadDisp = (event) => {
        this.setState({ filtroEntidadDisp: event.target.value })
      }

      onChangeFiltroEntidadAsig = (event) => {
        this.setState({ filtroEntidadAsig: event.target.value })
      }

      btnGuardarEntidadesClick = () => {
        var entidades = this.state.entidadesCliente.map(e => e.id)
        var restArgs = {
          method: 'PATCH',
          headers: 'JSON',
          body: {
            id_cliente: this.state.cliente.id,
            cliente: this.state.cliente.nombre + ' ' + this.state.cliente.codigo,
            entidades: entidades
          },
          url: process.env.REACT_APP_URL_BACKEND + '/clientes/cliente/entidades'
        }
        RestTunel.makePetition(restArgs, (err, data) => {
          if(err) {
            this.setState({
              mostrarAlerta: true,
              mensajeAlerta: 'Se produjo un error actualizando las entidades',
              severidadAlerta: 'error'
            })
          } else {
            this.setState({
              mostrarAlerta: true,
              mensajeAlerta: 'Entidades actualizadas',
              severidadAlerta: 'success'
            })
          }
        })
      }


    render() {
        var cliente = this.state.cliente

        return(
          <Box>

              <Typography gutterBottom variant="h5" component="div" sx={{ marginBottom: 2 }}>
                Editar Depositante
              </Typography>


                <Paper elevation={16}>
                  <Card>
                      <CardContent>
                          <form>
                              <FormLabel>Información Depositante</FormLabel>
                              <Grid container spacing={2} rowSpacing={2}>
                                <Grid item xs={6}>
                                  <FormControl fullWidth component="fieldset">
                                    <TextField
                                    label="Nombre"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={this.state.txtNombre}
                                    onChange={this.onChangetxtNombre}
                                    fullWidth
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                  <FormControl fullWidth component="fieldset">
                                      <TextField
                                      label="Identificación"
                                      id="outlined-basic"
                                      variant="outlined"
                                      value={this.state.txtCodigo}
                                      onChange={this.onChangetxtCodigo}
                                      InputProps={{ readOnly: true }}
                                      helperText="No editable"
                                      inputProps={{ inputMode: 'numeric', maxLength: 10 }}
                                      fullWidth
                                    />
                                </FormControl>
                                </Grid>
                              </Grid>
                          </form>
                      </CardContent>
                      <CardActions>
                              <Button  variant="contained" onClick={this.btnActualizarClienteClick}>Actualizar Informacion Cliente</Button>
                              <Snackbar
                                            open={this.state.mostrarAlerta}
                                            onClose={this.handleCloseAlert}
                                            autoHideDuration={3000}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                            >
                                            <Collapse in={this.state.mostrarAlerta}>
                                                <Alert
                                                    severity={this.state.severidadAlerta}
                                                    onClose={this.handleCloseAlert}
                                                    sx={{ marginTop: 4, width:'100%'}}
                                                    >
                                                <AlertTitle>
                                                    {this.state.severidadAlerta.toUpperCase()}
                                                </AlertTitle>
                                                    {this.state.mensajeAlerta}
                                                </Alert>
                                            </Collapse>
                              </Snackbar> 
                          </CardActions>
                  </Card>

                </Paper>
              

                <br />

                <Paper elevation={16}>
                    <Grid item xs={4}>
                        <Card>
                          <CardContent>
                            <Grid container spacing={2}>
                              <Grid item xs={4}>
                                <FormLabel>Cajeros Disponibles</FormLabel>
                                <List
                                  sx={{
                                    minHeight: 300,
                                    maxHeight: 300,
                                    overflow: 'auto'
                                  }}>
                                    {this.state.cajerosDisponibles.map((cajero) => (
                                    <ListItem 
                                      key={cajero.id} 
                                      classes={{ root: "ItemLista" }} 
                                      onClick={() => this.agregarCajero(cajero)}
                                    >
                                      {cajero.alias}
                                    </ListItem>
                                  ))}
                                </List>
                              </Grid>

                              {/* Grupos Disponibles */}
                              <Grid item xs={4}>
                                <FormLabel>Grupos Disponibles</FormLabel>
                                <List
                                  sx={{
                                    minHeight: 300,
                                    maxHeight: 300,
                                    overflow: 'auto'
                                  }}
                                >
                                  {this.state.gruposCajerosDisponibles.map((cajero) => (
                                    <ListItem 
                                      button 
                                      key={cajero.id} 
                                      classes={{ root: "ItemLista" }} 
                                      onClick={() => this.agregarCajero(cajero)}
                                    >
                                      {cajero.alias}
                                    </ListItem>
                                  ))}
                                </List>
                              </Grid>

                              {/* Cajeros/Grupos Funcionario */}        

                              <Grid item xs={4}>
                                <FormLabel>Cajeros/Grupos Depositante</FormLabel>
                                <List
                                  sx={{
                                    minHeight: 300,
                                    maxHeight: 300,
                                    overflow: 'auto'
                                  }}>
                                    {this.state.cajerosCliente.map((cajero) => (
                                    <ListItem 
                                      key={cajero.id} 
                                      classes={{ root: "ItemLista" }} 
                                      onClick={() => this.removerCajero(cajero)}
                                    >
                                      {cajero.tipo === 1 
                                        ? 'Cajero - ' + cajero.alias 
                                        : 'Grupo - ' + cajero.alias}
                                    </ListItem>
                                  ))}
                                </List>
                              </Grid>
                            </Grid>
                          </CardContent>
                          <CardActions>
                              <Button variant="contained" fullWidth onClick={this.btnGuardarCajerosClick}>Guardar Cajeros</Button>
                                <Snackbar
                                            open={this.state.mostrarAlerta}
                                            onClose={this.handleCloseAlert}
                                            autoHideDuration={3000}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                            >
                                            <Collapse in={this.state.mostrarAlerta}>
                                                <Alert
                                                    severity={this.state.severidadAlerta}
                                                    onClose={this.handleCloseAlert}
                                                    sx={{ marginTop: 4, width:'100%'}}
                                                    >
                                                <AlertTitle>
                                                    {this.state.severidadAlerta.toUpperCase()}
                                                </AlertTitle>
                                                    {this.state.mensajeAlerta}
                                                </Alert>
                                            </Collapse>
                                </Snackbar> 
                          </CardActions>
                        </Card>
                    </Grid>
                </Paper>
                <br />

                {/* ---------- Asignacion MULTIPLE de entidades ---------- */}
                <Paper elevation={16}>
                    <Grid item xs={12}>
                        <Card>
                          <CardContent>
                            <FormLabel>Entidades del Depositante</FormLabel>
                            <Grid container spacing={2} sx={{ marginTop: 0 }}>

                              {/* Entidades Disponibles */}
                              <Grid item xs={6}>
                                <FormLabel>Entidades Disponibles ({this.entidadesDisponiblesFiltradas().length})</FormLabel>
                                <TextField
                                  label="Buscar entidad"
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  value={this.state.filtroEntidadDisp}
                                  onChange={this.onChangeFiltroEntidadDisp}
                                  sx={{ marginTop: 1, marginBottom: 1 }}
                                />
                                <Button size="small" variant="outlined" onClick={() => this.agregarEntidadesFiltradas()} sx={{ marginBottom: 1 }}>
                                  Agregar todas (filtradas)
                                </Button>
                                <List sx={{ minHeight: 300, maxHeight: 300, overflow: 'auto' }}>
                                  {this.entidadesDisponiblesFiltradas().map((entidad) => (
                                    <ListItem
                                      button
                                      key={entidad.id}
                                      classes={{ root: "ItemLista" }}
                                      onClick={() => this.agregarEntidad(entidad)}
                                    >
                                      {entidad.nombre}
                                    </ListItem>
                                  ))}
                                </List>
                              </Grid>

                              {/* Entidades asignadas al Depositante */}
                              <Grid item xs={6}>
                                <FormLabel>Entidades Depositante ({this.state.entidadesCliente.length})</FormLabel>
                                <TextField
                                  label="Buscar asignada"
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  value={this.state.filtroEntidadAsig}
                                  onChange={this.onChangeFiltroEntidadAsig}
                                  sx={{ marginTop: 1, marginBottom: 1 }}
                                />
                                <Button size="small" variant="outlined" color="error" onClick={() => this.quitarEntidadesFiltradas()} sx={{ marginBottom: 1 }}>
                                  Quitar todas (filtradas)
                                </Button>
                                <List sx={{ minHeight: 300, maxHeight: 300, overflow: 'auto' }}>
                                  {this.entidadesAsignadasFiltradas().map((entidad) => (
                                    <ListItem
                                      button
                                      key={entidad.id}
                                      classes={{ root: "ItemLista" }}
                                      onClick={() => this.removerEntidad(entidad)}
                                    >
                                      {entidad.nombre}
                                    </ListItem>
                                  ))}
                                </List>
                              </Grid>

                            </Grid>
                          </CardContent>
                          <CardActions>
                            <Button variant="contained" fullWidth onClick={this.btnGuardarEntidadesClick}>Guardar Entidades</Button>
                          </CardActions>
                        </Card>
                    </Grid>
                </Paper>
                <br />

                <br />
                { session.checkPermiso('opcion_desactivar_depositante') &&
                    <Button variant="contained" onClick={() => {this.cambiarEstado()}}>{cliente.estado === "A" ? "Desactivar Depositante" : "Activar Depositante"}</Button>
                }

                  <Snackbar
                                                            open={this.state.mostrarAlerta}
                                                            onClose={this.handleCloseAlert}
                                                            autoHideDuration={3000}
                                                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                                            >
                                                            <Collapse in={this.state.mostrarAlerta}>
                                                                <Alert
                                                                    severity={this.state.severidadAlerta}
                                                                    onClose={this.handleCloseAlert}
                                                                    sx={{ marginTop: 4, width:'100%'}}
                                                                    >
                                                                <AlertTitle>
                                                                    {this.state.severidadAlerta.toUpperCase()}
                                                                </AlertTitle>
                                                                    {this.state.mensajeAlerta}
                                                                </Alert>
                                                            </Collapse>
                  </Snackbar> 
        

          </Box>
        )
    }

}


export default ClientesEditarPage